import { getPopularProducts } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  PopularProductsDummy,
  type PopularProductsServiceDTO,
  PopularProductsServiceDTOSchema,
} from './popular-products.dto';

export interface GetPopularProductsServiceRequest {
  snsTitle: string;
  page?: number;
  size?: number;
}

const transformPopularProducts = async (
  params: GetPopularProductsServiceRequest,
): Promise<PopularProductsServiceDTO> => {
  const { data, link } = await getPopularProducts(params);

  return {
    list: data.list.map((item) => ({
      ...PopularProductsDummy,
      goodsNo: String(item.goodsNo),
      salesRate: item.salesRate,
      imageUrl: item.imageUrl,
      brandName: item.brandName,
      goodsName: item.goodsName,
      linkUrl: item.linkUrl,
      price: item.price,
      isLiked: item.isLiked,
    })),
    total: link?.total ?? 0,
    pagination: {
      currentPage: params.page ?? 1,
      pageSize: params.size ?? 10,
      hasNextPage: !!link?.next,
      nextPage: link?.next ?? null,
    },
  };
};

export const getPopularProductsService = withServiceErrorCapture(
  lazyPipe(transformPopularProducts, validateServiceResponse(PopularProductsServiceDTOSchema)),
);
